import { Api } from '../api';
import { ICreateChaveValor, IResponseChaveValor } from 'shared/types/chaveValor';

const getAll = async (filter = ''): Promise<IResponseChaveValor | Error> => {
  try{
    const { data, status } = await Api.get(`/ChaveValor/chaveValor?Sistema=10&${filter}`);
    // const { data, status } = await Api.get(`/ChaveValor/chaveValor?Sistema=10${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id:string): Promise<IResponseChaveValor | Error> => {
  try{
    const { data, status } = await Api.get(`/ChaveValor/chaveValor?codigo=${id}`);
    if (data) {
      console.log(data.retornoPagina);
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const deleteById = async (id:string): Promise<IResponseChaveValor | Error> => {
  try{
    const { data, status } = await Api.get(`/ChaveValor/chaveValor?codigo=${id}`);
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const updateById = async (id: string, dados: ICreateChaveValor,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/ChaveValor/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
const create = async (dados: ICreateChaveValor,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put('/Orgs/', dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

export const ChaveValorService = {
  getAll,
  updateById,
  create,
  getById,
  deleteById
};
